import React,{ReactElement} from "react";
import classnames from 'classnames';

let Styles: any;

try {
    Styles = require('./Buttons_' + process.env.REACT_APP_CODE_TENANT + '.module.scss');
}
catch{
    Styles = require('./Buttons.module.scss');
}

interface ButtonProps {
  id: string,
  onClick: any,
  type?:  "button" | "submit" | "reset" | undefined
  textoButton: string | ReactElement,
  styleClass: string,
  minWidth?: string,
  maxWidth?: string,
  disabled?: boolean,
  iconBack?: ReactElement,
  iconNext?: ReactElement,
}

const Button: React.FC<ButtonProps> = (props: ButtonProps) => {
  const { textoButton, styleClass, minWidth, maxWidth, iconBack, iconNext, ...rest } = props;
  return (
    <button
      {...rest}
      className={classnames(Styles.defaultButton, styleClass)}
      style={{ minWidth: minWidth, maxWidth: maxWidth }}
    > {iconBack}{textoButton}{iconNext}
    </button>
  );
};

export default Button;